function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.876 3.008L3 3.118v10.557a7 7 0 003.29 5.935l5.18 3.238.53.331.53-.331 5.18-3.238A7 7 0 0021 13.675V3.117l-.876-.11-8-1L12 1.993l-.124.016-8 1z",
  fill: "url(#security-on_svg__paint0_linear)",
  stroke: "#fff",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 4v9.675a6 6 0 01-2.82 5.087L12 22V3l8 1z",
  fill: "url(#security-on_svg__paint1_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 11.438L10.685 13 15 9",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-on_svg__paint0_linear",
  x1: 11.814,
  y1: 4.142,
  x2: 11.814,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#76CF9C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#279255"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "security-on_svg__paint1_linear",
  x1: 11.814,
  y1: 4.142,
  x2: 11.814,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#31B76A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#18663A"
})));

var SvgSecurityOn = function SvgSecurityOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 25",
    fill: "none"
  }), _ref, _ref2, _ref3, _ref4);
};

export default SvgSecurityOn;